import {fromAction, AppActionType} from '../actions/Error';

export function appBridgeMiddlewareProptype(
  object: any,
  key: string,
  componentName: string /*, ...rest: any[]*/,
): Error | null {
  const propValue = object[key];

  if (
    !propValue ||
    !propValue.load ||
    (propValue.load && !(typeof propValue.load === 'function'))
  ) {
    return fromAction(
      `Expected an instance of the App Bridge middleware for \`${key}\` in \`${componentName}\``,
      AppActionType.MISSING_APP_BRIDGE_MIDDLEWARE,
    );
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/host/PropTypes.ts